import { arrayOf, bool, func, string } from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { noop } from 'lodash';
import ReactTagsInput from 'react-tagsinput';
import InputTag from '../IndustriesPicker/InputTag';
import { REMOVE_TAGS_KEYCODES } from '../../shared/constants';
import { MPI_INDUSTRIES_FILTER_MAX_TAGS } from '../filters/shared/constants';
import classes from './index.module.scss';
import useIndustryPicker from './hooks/useIndustryPicker';

const IndustryPicker = ({
    values = [],
    className = '',
    onChange,
    placeholder = '',
    hideTags = false,
    isMobile,
}) => {
    const {
        tagsInputProps,
        tagProps,
        autocompleteRenderInput,
        inputValue,
        handleInputChange,
        inputRef,
        renderLayout,
    } = useIndustryPicker({ values, hideTags, placeholder, isMobile });

    return (
        <ReactTagsInput
            onChange={onChange}
            className={cn(
                classes.industriesPicker,
                isMobile && classes.industriesPickerMobile,
                className
            )}
            ref={inputRef}
            onlyUnique={true}
            value={values}
            inputValue={inputValue}
            addKeys={[]}
            onChangeInput={handleInputChange}
            addOnBlur={false}
            renderLayout={renderLayout}
            renderInput={autocompleteRenderInput}
            removeKeys={hideTags ? [] : REMOVE_TAGS_KEYCODES}
            renderTag={hideTags ? noop : InputTag}
            inputProps={tagsInputProps}
            tagProps={tagProps}
            maxTags={MPI_INDUSTRIES_FILTER_MAX_TAGS}
        />
    );
};

IndustryPicker.propTypes = {
    values: arrayOf(string),
    className: string,
    onChange: func,
    placeholder: string,
    hideTags: bool,
    isMobile: bool,
};

export default IndustryPicker;
